import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import ServicesPreview from './components/ServicesPreview';
import ProcessPreview from './components/ProcessPreview';
import IndustriesPreview from './components/IndustriesPreview';
import HomeCTA from './components/HomeCTA';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <ServicesPreview />
      <ProcessPreview />
      <IndustriesPreview />
      <HomeCTA />
      <Footer />
    </div>
  );
}
